import Vue from 'vue'
import App from './App.vue'
import router from './router'

// import jquery from 'jquery'
// jquery.ajaxSetup({
//     cache : false
// });

// const Vue = require('vue')
// const jquery = require('jquery')
// jquery.ajaxSetup({
//     cache : false
// });

// import axios from 'axios'
// import VueAxios from 'vue-axios'
// Vue.use(VueAxios, axios);


// import $ from 'jquery'
// Vue.use($);

// console.log($.fn.jquery)
import '@/assets/less/base.less'
// import '@/assets/less/module.less'

// 设置为 false 以阻止 vue 在启动时生成生产提示
Vue.config.productionTip = false

// 定义全局变量方法
// Vue.prototype.baseUrl = function () {  
//   return location.href;  
// };  

// 定义全局方法
import baseFun from './utils/base.js'
Vue.use(baseFun)

// 定义全局变量
import global_ from './global/global.vue'
Vue.prototype.GLOBAL = global_

new Vue({
  render: h => h(App),
  router,
}).$mount('#app')

// isIphoneX = window.devicePixelRatio && window.devicePixelRatio === 3 && window.screen.width === 375 && testUA('iPhone')
